export default __webpack_public_path__ + "static/media/编组.d64a25bc.png";